import { APProgramDetailsQuery } from '../../../../../plan/queries/ap_program_details_query';
import { IFeedbackTransaction } from '../../builders/plan_feedback_transaction_builder';

class PlanFeedbackTemplateChangesContainer {
  private suggestions: IFeedbackTransaction[];
  private suggestionHidden = false;

  constructor(
    private performActionOnFeedbackHelper: ng.IServiceProviderFactory,
    private ngAPProgramDetailsQuery: APProgramDetailsQuery
  ) {}

  acceptAllSuggestions() {
    const nks = this.suggestions.map((sgstn) => sgstn['nk']);
    this.performActionOnFeedbackHelper(this.suggestions, 'ACCEPT', nks, 'TEMPLATE');
  }
  toggleSuggestions() {
    this.suggestionHidden = !this.suggestionHidden;
  }
}

angular.module('capability-ng-academic-planner').component('planFeedbackTemplateChangesContainer', {
  templateUrl:
    'capability-ng-academic-planner/src/suggestions/components/plan_feedback/components/plan_feedback_template_changes_container/plan_feedback_template_changes_container.html',
  controller: PlanFeedbackTemplateChangesContainer,
  bindings: {
    suggestions: '<'
  }
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/suggestions/components/plan_feedback/components/plan_feedback_template_changes_container/plan_feedback_template_changes_container.ts